import { render } from "./CorporationData_v2.vue?vue&type=template&id=5841b8d4"
import script from "./CorporationData_v2.vue?vue&type=script&lang=js"
export * from "./CorporationData_v2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__